import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m20 17-5-5 5-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4 17 5-5-5-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronsRightLeft";
const ChevronsRightLeft = memo(themed(Icon));
export {
  ChevronsRightLeft
};
//# sourceMappingURL=chevrons-right-left.js.map
